import angular from 'angular'
import './sets.service'
import './edition/edition.controller'
import './waitlist/waitlist.controller'
import './waitlist/waitlist.service'

angular
  .module('pub.sets', ['pub.sets.service', 'pub.sets.edition', 'pub.sets.waitlist'])
  .controller('SetsCtrl', SetsCtrl)

/** @ngInject */
function SetsCtrl(
  $scope,
  $state,
  $filter,
  UploadService,
  $rootScope,
  $timeout,
  $stateParams,
  SetsService,
  BundleService,
  CacheService,
  ChannelsService,
  TagsService,
) {
  var vm = this
  vm.loading = true
  vm.items = []
  vm.busy = false
  $('#myModal').modal('hide')
  vm.sortType = 'ts-p-desc'
  vm.sortReverse = false
  vm.title = ''

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 20
    vm.currentPage = 20
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  vm.filter = 'Sort'
  vm.sort = ['Sort', 'Date: Newest', 'Date: Oldest']

  vm.sortBy = function () {
    switch (vm.filter) {
      case 'Date: Newest':
        vm.items = $filter('orderBy')(vm.items, '-ts')
        break
      case 'Date: Oldest':
        vm.items = $filter('orderBy')(vm.items, 'ts')
        break
      case 'Sort':
        vm.items = $filter('orderBy')(vm.items, '-n')
        break
    }
  }

  CacheService.urls('', '', true)
  localStorage.setItem('channelId', $stateParams.parentId)

  ChannelsService.getId($stateParams.parentId).then(function (result) {
    vm.channels = result.results
    $rootScope.channelName = vm.channels.t
    $rootScope.channelImage = vm.channels['img-t']
  })

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 20
      vm.oldPage = vm.currentPage - 20
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    SetsService.list($stateParams.parentId, vm.title, vm.oldPage, 20, vm.sortType).then(
      function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }
        const status = {
          0: 'Draft',
          1: 'Published',
          2: 'Sold Out',
          3: 'Unavailable',
          4: 'Awaiting Collectible Count',
          5: 'Coming Soon',
          6: 'Archived',
        }

        const strategy = {
          0: 'Standard',
          1: 'Award',
          2: 'Collectors Edition',
        }

        const productType = {
          1: 'Sticker',
          2: 'Card',
          3: 'Figure',
        }

        for (var i = 0; i < result.results.length; i++) {
          const item = result.results[i]
          if (item['ts-p'] !== undefined && item['ts-p'] !== null) {
            item['ts-p'] = new Date(
              parseInt(item['ts-p'].toString().substring(0, item['ts-p'].toString().length - 3)),
            )
          } else {
            item['ts-p'] = ''
          }

          // Add Type
          item.type = productType[item['k-prod']] ?? 'Unknown'

          //Add status
          item.status = status[item.st] ?? 'Unknown'

          // Add Strategy
          item.strategy = strategy[item.k] ?? 'Unknown'
        }

        vm.sortType = oldSortType
        vm.items = result.results

        vm.loading = false
      },
    )
  }

  load(1)

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  vm.next = function (item) {
    if (item.step === 1) {
      $state.go('pub.collectibles', { parentId: item.id })
    } else if (item.step === 2) {
      $state.go('pub.bundles', { parentId: item.id })
    } else if (item.step === 3) {
      $state.go('pub.reviews', { parentId: item.id })
    } else {
      $state.go('pub.channels.sets.edit', { id: item.id })
    }
  }

  vm.ordinal_suffix_of = function (i) {
    var j = i % 10,
      k = i % 100
    if (j == 1 && k != 11) {
      return i + 'st'
    }
    if (j == 2 && k != 12) {
      return i + 'nd'
    }
    if (j == 3 && k != 13) {
      return i + 'rd'
    }
    return i + 'th'
  }

  vm.bundleStatus = function (item) {
    item.tooltip = ''

    if (item.st === 1) {
      item.status = 'Published'
      item.step = 3
      item.tooltip += '<p style="color:#333;">Published: Yes </p>'
      item.tooltip += "<p style='color:#333;'>" + vm.ordinal_suffix_of(item.e) + ' Edition</p>'
      return
    }

    BundleService.getSetId(item.id, 0, 120).then(function (result) {
      var bundles = result.results
      item.tooltip += '<p style="color:#333;">Bundles: ' + bundles.length + '</p>'
      if (bundles.length > 0) {
        item.step = 2
      } else {
        item.step = 1
      }
      item.status = ''

      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].st === 0) {
          item.status = 'Bundles incomplete'
        }
      }

      if (bundles.length > 0) {
        if (item.status === '') {
          item.status = 'Bundles complete'
          item.step = 3
        }
      }
      item.tooltip += "<p style='color:#333;'>" + vm.ordinal_suffix_of(item.e) + ' Edition</p>'
      item.tooltip += "<p style='color:#333;'>Published: No (step " + item.step + ' of 3)</p>'
    })
  }

  vm.publish = function (item) {
    SetsService.publish(item.id).then(function () {
      item.st = 1
      swal('Published with success!')
    })
  }

  vm.changeOrder = function (item, currentList) {
    vm.order = null
    vm.currentItem = item
    vm.currentList = currentList || []
    $('#myModalOrder').modal('show')
  }

  vm.saveOrder = function () {
    if (!vm.order) {
      $timeout(function () {
        swal('Field required', '', 'error')
      }, 300)
      return
    }

    SetsService.reorder($stateParams.parentId, vm.currentItem.id, parseInt(vm.order)).then(
      function () {
        $('#myModalOrder').modal('hide')
        toastr.success('Order updated successfully!')
        load(vm.pagination.current || 1)
      },
      function (err) {
        $timeout(function () {
          var errorMessage =
            err && err.error && err.error.message
              ? err.error.message
              : 'An error occurred while saving the order'
          swal('Error', errorMessage, 'error')
        }, 300)
      },
    )
  }

  vm.deleteSet = function (item) {
    swal(
      {
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: false,
        type: 'warning',
        animation: 'slide-from-top',
        allowEscapeKey: false,
        allowOutsideClick: false,
      },
      function (isConfirm) {
        if (!isConfirm) {
          return
        }

        SetsService.remove(item.id).then(function () {
          swal('Deleted!', 'success')
          vm.sortType = 'ts-p-desc'
          vm.sortReverse = false
          load()
        })
      },
    )
  }

  vm.clone = function (item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want clone this set',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          SetsService.clone(item.id).then(
            function () {
              swal('Cloned with success', '', 'success')
              reloadPagination()
              load(1)
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              swal({
                title: 'Error for Clone this channel',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  vm.classDisabled = function () {
    if (!vm.title) {
      return 'is-disabled'
    }
  }

  vm.saveSet = function () {
    SetsService.save($stateParams.parentId, {
      t: vm.titleNew,
      ra: true,
      'color-hl': vm.channels['color-hl'],
      'color-bg': vm.channels['color-bg'],
      'color-txt': vm.channels['color-txt'],
    }).then(function (result) {
      TagsService.addTagSet(result.results.id, vm.channels.tags).then(function () {
        toastr.success('Saved!')
        $state.go('pub.channels.sets.edit', {
          parentId: $stateParams.parentId,
          id: result.results.id,
        })
        $('html, body').animate({ scrollTop: 0 }, 1000)
      })
    })
  }

  $('.showProduct').hide()

  vm.fixOrder = function (item) {
    SetsService.fixOrder(item.id).then(
      function () {
        toastr.success('Fixed!')
      },
      function () {
        toastr.error('Try again!')
      },
    )
  }

  vm.fixTop100 = function (item) {
    SetsService.fixTop100(item.id).then(
      function () {
        toastr.success('Fixed!')
      },
      function () {
        toastr.error('Try again!')
      },
    )
  }

  vm.publishComingSoon = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: 'Do you want publish this Set',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          SetsService.publishComingSoon(item.id).then(function () {
            toastr.success('Published!')
            reloadPagination()
            load(1)
          })
        }
      },
    )
  }

  vm.waitlist = function (item) {
    $state.go('pub.channels.sets.waitlist', {
      parentId: $stateParams.parentId,
      id: item.id,
    })
  }

  vm.options = [
    { id: 1, t: 'Sticker' },
    { id: 2, t: 'Card' },
    { id: 3, t: 'Figure' },
  ]

  vm.listProductTypes = vm.options

  $('#myModal').on('shown.bs.modal', function () {
    $('#setTitle').focus()
  })

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    vm.items = []
    load()
  }

  vm.setsTranslations = []
  vm.translate = {}
  vm.pathImgTTranslation = ''
  vm.pathImgHTranslation = ''
  vm.loadTTranslation = false
  vm.loadHTranslation = false
  vm.translations = function (item) {
    vm.itemSelected = item
    loadTranslations()
    $('#modalTranslate').modal('show')
  }

  vm.translate = {}
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslateAdd').modal('show')
  }

  function loadTranslations() {
    SetsService.listTranslations(vm.itemSelected.id).then(function (result) {
      vm.setsTranslations = result.results
    })
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate.txt) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      vm.translate['id-s'] = vm.itemSelected.id
      SetsService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      vm.translate['id-s'] = vm.itemSelected.id
      SetsService.createTranslation(vm.itemSelected.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    SetsService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslateAdd').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          SetsService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslateAdd').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTTranslation = function (item) {
    vm.loadTTranslation = true
    UploadService.save('sets', vm.pathImgTTranslation, 'img-t', item.id).then(function (fileName) {
      vm.loadTTranslation = false
      item['img-t'] = fileName
    })
  }

  vm.uploadHTranslation = function (item) {
    vm.loadHTranslation = true
    UploadService.save('sets', vm.pathImgHTranslation, 'img-h', item.id).then(function (fileName) {
      vm.loadHTranslation = false
      item['img-h'] = fileName
    })
  }

  var watch = $scope.$watch('vm.title', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPagination()
        load(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.title.length < 2) {
      return
    }

    reloadPagination()
    load(1)
  })

  $scope.$on('$destroy', function () {
    watch()
  })
}
